export default __webpack_public_path__ + "static/media/profile-picture-5.fff93226.jpg";